module.exports = __webpack_public_path__ + "02_glasses_black.41d6efc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/02_glasses_black.png
// module id = 0w2E
// module chunks = 0